import { BillingInterval, BillingModel } from '@graphql';

export interface IManagePlansAndSeatsFormikValues {
  currentTierId: string;
  purchasedSeats: number;
  billingInterval: BillingInterval;
  billingModel: BillingModel;
  startDate: string | null;
  endDate: string | null;
  trialPeriodDays?: number | null;
}

export enum ChangePlanType {
  TIER_CHANGE = 'tier_change',
  BILLING_MODEL_CHANGE = 'billing_model_change',
}

export const BillingModelLabels: Record<BillingModel, string> = {
  [BillingModel.CREDIT_CARD]: 'Credit Card',
  [BillingModel.INVOICE]: 'Invoice',
};

export enum StripeSubscriptionStatus {
  incomplete = 'incomplete',
}